class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]"
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.recentSearches =
      JSON.parse(localStorage.getItem("recentSearches")) || [];

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
    this.addEventListener("click", this.onClick.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      document
        .getElementById("predictive-search-option-search-keywords")
        .classList.add("hidden");
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();

    this.handleRecentSearch(this.searchTerm);
  }

  removeSearchTerm(searchTerm) {
    this.recentSearches = this.recentSearches.filter(
      (term) => term !== searchTerm
    );
    this.saveRecentSearches();
    this.renderRecentSearches();
  }

  renderRecentSearches() {
    this.predictiveSearchResults.querySelector(
      "#recent-searches-list"
    ).innerHTML = "";

    this.recentSearches.forEach((searchTerm) => {
      const listItem = document.createElement("li");
      listItem.innerHTML = `<a href="/search?q=${searchTerm.replace(
        /\s+/g,
        "+"
      )}">${searchTerm}</a>`;

      // Create remove button
      const removeButton = document.createElement("span");
      removeButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 15C11.8447 15 15 11.8396 15 7.99669C15 4.16044 11.8381 1 8 1C4.1553 1 1 4.16044 1 7.99669C1 11.8396 4.16193 15 8 15ZM5.91193 10.8457C5.48769 10.8457 5.15625 10.5078 5.15625 10.0771C5.15625 9.885 5.2358 9.69285 5.38163 9.55372L6.92614 8.00994L5.38163 6.46616C5.2358 6.3204 5.15625 6.13488 5.15625 5.94274C5.15625 5.50544 5.48769 5.18079 5.91193 5.18079C6.14394 5.18079 6.31629 5.25367 6.46875 5.39943L8 6.92996L9.54451 5.39943C9.7036 5.24042 9.87595 5.17416 10.1013 5.17416C10.5256 5.17416 10.857 5.50544 10.857 5.92948C10.857 6.12825 10.7841 6.31377 10.6316 6.45954L9.08712 8.00994L10.625 9.54709C10.7775 9.69285 10.857 9.87837 10.857 10.0771C10.857 10.5078 10.5256 10.8457 10.0947 10.8457C9.86932 10.8457 9.67708 10.7662 9.53125 10.6204L8 9.08992L6.47538 10.6204C6.32955 10.7662 6.14394 10.8457 5.91193 10.8457Z" fill="#16161A"/>
        </svg>
        `;
      removeButton.className = "remove-button";
      removeButton.onclick = (event) => {
        this.removeSearchTerm(searchTerm);
        event.stopPropagation();
      };

      listItem.appendChild(removeButton);

      const recentIcon = document.createElement("span");
      recentIcon.innerHTML = `
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 9.41941C0 13.06 3.13077 16 7 16C10.8769 16 14 13.06 14 9.41941C14 8.85598 13.5846 8.46591 13 8.46591C12.4231 8.46591 12.0308 8.85598 12.0308 9.41941C12.0308 12.0271 9.78462 14.1363 7 14.1363C4.21538 14.1363 1.98462 12.0271 1.98462 9.41941C1.98462 6.75395 4.16154 4.66637 6.93846 4.66637C7.3 4.66637 7.63077 4.68804 7.92308 4.7386L6.19231 6.34944C6.02308 6.50835 5.91538 6.69616 5.91538 6.94898C5.91538 7.45463 6.33846 7.85192 6.87692 7.85192C7.14615 7.85192 7.36923 7.76524 7.54615 7.60632L10.6846 4.6158C10.8923 4.42077 10.9923 4.20406 10.9923 3.94402C10.9923 3.6912 10.8846 3.45282 10.6846 3.27223L7.54615 0.267269C7.36923 0.0939052 7.14615 0 6.87692 0C6.33846 0 5.91538 0.411738 5.91538 0.924605C5.91538 1.17743 6.02308 1.36524 6.18462 1.53138L7.71538 2.93995C7.48462 2.90384 7.20769 2.87494 6.93846 2.87494C3.07692 2.87494 0 5.77156 0 9.41941Z" fill="#16161A"/>
      </svg>
      `;
      recentIcon.className = "recent-icon";
      listItem.appendChild(recentIcon);

      this.predictiveSearchResults
        .querySelector("#recent-searches-list")
        .appendChild(listItem);
    });
    if (this.recentSearches.length) {
      this.predictiveSearchResults
        .querySelector("div.recent-search")
        .classList.remove("hidden");
    } else {
      this.predictiveSearchResults
        .querySelector("div.recent-search")
        .classList.add("hidden");
    }
  }

  saveRecentSearches() {
    localStorage.setItem("recentSearches", JSON.stringify(this.recentSearches));
  }

  addSearchTerm(searchTerm) {
    if (!this.recentSearches.includes(searchTerm)) {
      this.recentSearches.unshift(searchTerm);
      this.recentSearches = this.recentSearches.slice(0, 3); // Limit recent searches to 5
      this.saveRecentSearches();
      // this.renderRecentSearches();
    }
  }

  handleRecentSearch(searchTerm) {
    if (searchTerm !== "") {
      this.addSearchTerm(searchTerm);
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
      this.close();
      document
        .getElementById("predictive-search-option-search-keywords")
        .classList.add("hidden");
    }
  }

  onClick(event) {
    if (event.target.matches(".predictive-search--header .modal-overlay")) {
      this.close();
    }
  }

  onFocus() {
    this.open();
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    if (window.innerWidth < 768) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    // fetch(
    //   `${routes.predictive_search_url}?type=product&q=${encodeURIComponent(
    //     searchTerm
    //   )}&${encodeURIComponent("resources[type]")}=product&${encodeURIComponent(
    //     "resources[limit]"
    //   )}=8&section_id=predictive-search`
    // )

    // fetch(
    //   `${routes.predictive_search_url}?q=${encodeURIComponent(
    //     searchTerm
    //   )}&section_id=predictive-search`,
    //   {
    //     signal: this.abortController.signal,
    //   }
    // )

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search&${encodeURIComponent(
        "resources[limit]"
      )}=8`,
      {
        signal: this.abortController.signal,
      }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  updateSearchCount(searchTerm) {
    fetch(
      `/search?q=${encodeURIComponent(
        searchTerm
      )}&section_id=main-search-results-count`
    )
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        const searchCount = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#ss-search-results-count").innerHTML;

        document
          .getElementById("predictive-search-option-search-keywords")
          .querySelector(
            ".search-results-count"
          ).innerHTML = `View all ${searchCount} results`;

        document
          .getElementById("predictive-search-option-search-keywords")
          .classList.remove("hidden");
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        // this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.updateSearchCount(this.searchTerm);
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        .textContent
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
    // document.body.style.overflow = "hidden";
    this.renderRecentSearches();
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    // document.body.style.overflow = "visible";
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}

customElements.define("predictive-search", PredictiveSearch);
